module.exports = __webpack_public_path__ + "static/media/bg_main_2.de659871.png";